import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import RequestReview from "@/pages/RequestReview";
import AdminLeads from "@/pages/AdminLeads";
import Audit from "@/pages/Audit";
import { Privacy, Terms } from "@/pages/Legal";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RequestReview />} />
          <Route path="/request-review" element={<RequestReview />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="*" element={<Navigate to="/request-review" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
